import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { loadFeatureGate } from './actions/load-feature-gate';
import {
  featureGatesForUsernameFlag,
  featureGatesStateForUsernameFlag,
} from './feature-gate-selectors';
import { userSelector } from '../reducers/current-user-selectors';

import { useThunkDispatch } from '../util/use-thunk-dispatch';

export const useFeatureGate = (gateName: string) => {
  const currentUser = useSelector(userSelector);
  const featureGate = useSelector((state: any) =>
    currentUser ? featureGatesForUsernameFlag(state, currentUser?.username, gateName) : null,
  );
  const featureGateState = useSelector((state: any) =>
    currentUser ? featureGatesStateForUsernameFlag(state, currentUser?.username, gateName) : null,
  );

  const dispatch = useThunkDispatch();

  useEffect(() => {
    if (currentUser) {
      dispatch(loadFeatureGate(currentUser, gateName));
    }
  }, [currentUser, dispatch, gateName, featureGateState]);

  return { isEnabled: featureGate?.isEnabled, isLoading: featureGateState?.loading };
};
